import { render } from "./MyPatientItem.vue?vue&type=template&id=3ff0cbda&ts=true"
import script from "./MyPatientItem.vue?vue&type=script&lang=ts"
export * from "./MyPatientItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__